angular.module('smartorg.r6.mgmts.legalMessage').directive('legalMessageDisplay', [function () {
        return {
            restrict: 'E',
            template: require('../../template/legal-message-display.html'),
            scope: {
                callback: '&?'
            },
            link: function (scope) {
                if (!scope.callback) {
                    alert("System Error!");
                }
                /**
                 * Wrap the callback function for easy access.
                 *
                 * @param type {string} Message type. Should be "LICENSE"
                 *     or SECURITY_WARNING_WB.
                 * @param result {string} Should be "accepted", "declined",
                 *     or "error".
                 * @param message {string} Extra message to display.
                 */
                scope.emitToControl = function (type, result, message) {
                    scope.callback({
                        type: type,
                        result: result,
                        message: message
                    });
                };
                /**
                 * On user accept the legal message. Call api to update
                 * database then emit accepted to firstpage.
                 */
                scope.acceptLegal = function () {
                    scope.emitToControl(scope.messageType, "accepted", "");
                };
                /**
                 * On user decline the legal message. Emit declined.
                 */
                scope.declineLegal = function () {
                    scope.emitToControl(scope.messageType, "declined", "");
                };
                /**
                 * Handle loading.
                 */
                scope.$on('manage:LEGAL_DISPLAY', function (event, args) {
                    scope.messageType = args.messageType;
                    scope.message = decodeURIComponent(atob(args.message));
                    if (scope.messageType === 'LICENSE') {
                        scope.messageTypeDisplay = "License";
                    }
                    else if (scope.messageType === 'SECURITY_WARNING_WB') {
                        scope.messageTypeDisplay = "Security Warning Message";
                    }
                    else {
                    }
                });
            }
        };
    }]);
//# sourceMappingURL=legal-message-display-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/legal-message/app/js/plumbing/legal-message-display-directive.js